import { render, staticRenderFns } from "./type1.vue?vue&type=template&id=bc5d4216&scoped=true&"
import script from "./type1.vue?vue&type=script&lang=js&"
export * from "./type1.vue?vue&type=script&lang=js&"
import style0 from "./type1.vue?vue&type=style&index=0&id=bc5d4216&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5d4216",
  null
  
)

export default component.exports